import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppUtils } from 'presto-mini-apps-lib';
import LoyaltyTypeInputModal from '../../components/LoyaltyTypeInputModal';
import LoyaltyTypePinModal from '../../components/LoyaltyTypePinModal';
import LoyaltyMessageModal from '../LoyaltyMessageModal';
import {
    term_addLoyalty, 
    term_loyaltyDisclaimerLine,
    phrase_LoyaltySupplementaryTitle,
    phrase_LoyaltySupplementaryMessage,
    phrase_LoyaltyInsufficentAmountTitle,
    phrase_LoyaltyInsufficentAmountMessage,
    phrase_LoyaltySufficentAmountTitle,
    phrase_LoyaltySufficentAmountMessage,
    phrase_LoyaltyLimitReachTitle,
    phrase_LoyaltyLimitReachMessage,
} from '../../constants/text';
import {LoyaltyInfoAccountStatus} from '../../constants/statusCode';
import LoyaltyTypeOtpModal from '../LoyaltyTypeOtpModal';

class LoyaltyTypeMultiSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isSelectorOpen: false,
            isManualInputModalOpen: false,
            isPinModalOpen: false,
            isOtpModalOpen: false,
            isMessageModalOpen: false,
            modalTitle: '',
            modalMessage: '',
            selectedLoyaltyItem: null,
            clearField: false,
            defaultInputPaymentAmount: null,
        };
    }

    onToggleHandler = (e) => {
        this.setState({
            isSelectorOpen: !this.state.isSelectorOpen
        });
    };

    onSelectHandler = (loyaltyItem) => {
        const { selectedList, amountToPay } = this.props;
        let _selectedItem = selectedList.filter(item => (item.id === loyaltyItem.id));

        if (LoyaltyInfoAccountStatus.NormalSupplementary === loyaltyItem.accountStatus 
            || LoyaltyInfoAccountStatus.MissingPoints === loyaltyItem.accountStatus) {
                this.setState({
                    isManualInputModalOpen: false,
                    isPinModalOpen: false,
                    isOtpModalOpen: false,
                    isMessageModalOpen: true,
                    modalTitle: phrase_LoyaltySupplementaryTitle,
                    modalMessage: phrase_LoyaltySupplementaryMessage,
                    selectedLoyaltyItem: loyaltyItem,
                });
            return;
        } else if (LoyaltyInfoAccountStatus.NormalPrincipalPINRequired === loyaltyItem.accountStatus) {
            this.setState({
                isManualInputModalOpen: false,
                isPinModalOpen: true,
                isOtpModalOpen: false,
                selectedLoyaltyItem: loyaltyItem,
                clearField: true,
            }, () => this.setState({ clearField: false }));
            return;
        } else if (LoyaltyInfoAccountStatus.NormalPrincipalOTPRequired === loyaltyItem.accountStatus) {
            this.setState({
                isManualInputModalOpen: false,
                isPinModalOpen: false,
                isOtpModalOpen: true,
                selectedLoyaltyItem: loyaltyItem,
                clearField: true,
            }, () => this.setState({ clearField: false }));
            return;
        } else if (loyaltyItem.transactionLimited) {
            this.setState({
                isManualInputModalOpen: false,
                isPinModalOpen: false,
                isOtpModalOpen: false,
                isMessageModalOpen: true,
                modalTitle: phrase_LoyaltyLimitReachTitle,
                modalMessage: phrase_LoyaltyLimitReachMessage(loyaltyItem.transactionLimited)
            });
            return;
        } else if (amountToPay === 0 && _selectedItem.length === 0) {
            this.setState({
                isManualInputModalOpen: false,
                isPinModalOpen: false,
                isOtpModalOpen: false,
                isMessageModalOpen: true,
                modalTitle: phrase_LoyaltySufficentAmountTitle,
                modalMessage: phrase_LoyaltySufficentAmountMessage
            });
            return;
        } else if ((amountToPay < loyaltyItem.minCents || loyaltyItem.maxRedeemableCents < loyaltyItem.minCents) && loyaltyItem.balance >= loyaltyItem.minCents && _selectedItem.length === 0) {
            this.setState({
                isManualInputModalOpen: false,
                isPinModalOpen: false,
                isOtpModalOpen: false,
                isMessageModalOpen: true,
                modalTitle: phrase_LoyaltyInsufficentAmountTitle,
                modalMessage: phrase_LoyaltyInsufficentAmountMessage(PrestoAppUtils.convertToCurrency(+loyaltyItem.minCents / 100)),
                selectedLoyaltyItem: loyaltyItem,
            });
            return;
        } else if (loyaltyItem.balance === 0 || loyaltyItem.maxRedeemableCents < loyaltyItem.minCents) {
            this.setState({
                isManualInputModalOpen: false,
                isPinModalOpen: false,
                isOtpModalOpen: false,
                isMessageModalOpen: true,
                modalTitle: loyaltyItem.insufficientTitle,
                modalMessage: loyaltyItem.insufficientMessage,
                selectedLoyaltyItem: loyaltyItem,
            });
            return;
        }

        var defaultInputPaymentAmount = null;
        if (_selectedItem.length > 0) {
            defaultInputPaymentAmount = PrestoAppUtils.convertToCurrency(+(_selectedItem[0].amount) / 100);
        } else {
            defaultInputPaymentAmount = PrestoAppUtils.convertToCurrency(+(loyaltyItem.maxRedeemableCents < amountToPay ? loyaltyItem.maxRedeemableCents : amountToPay) / 100);
        }

        this.setState({
            isManualInputModalOpen: true,
            isPinModalOpen: false,
            isOtpModalOpen: false,
            selectedLoyaltyItem: loyaltyItem,
            defaultInputPaymentAmount: defaultInputPaymentAmount,
            isSelectorOpen: false,
            clearField: true,
        }, () => this.setState({ clearField: false }));
    };

    onCloseModalHandler = () => {
        this.setState({
            isManualInputModalOpen: false,
            isPinModalOpen: false,
            isOtpModalOpen: false,
            selectedLoyaltyItem: null,
            isMessageModalOpen: false,
            defaultInputPaymentAmount: null,
        });
    };

    onClosePinModalHandler = () => {
        this.setState({
            isManualInputModalOpen: false,
            isPinModalOpen: false,
            isOtpModalOpen: false,
            isMessageModalOpen: false,
            selectedLoyaltyItem: null,
            defaultInputPaymentAmount: null,
        });
    };

    onCloseMessageModalHandler = () => {
        this.setState({
            isManualInputModalOpen: false,
            isPinModalOpen: false,
            isOtpModalOpen: false,
            isMessageModalOpen: false,
            selectedLoyaltyItem: null,
            defaultInputPaymentAmount: null,
            isSelectorOpen: false,
        });
    };

    onRemoveModalHandler = () => {
        const { onSelectRemove } = this.props;
        const { selectedLoyaltyItem } = this.state;
        if (typeof onSelectRemove === 'function') {
            onSelectRemove(selectedLoyaltyItem.id);
        }

        this.setState({
            isManualInputModalOpen: false,
            isPinModalOpen: false,
            isOtpModalOpen: false,
            selectedLoyaltyItem: null,
            defaultInputPaymentAmount: null,
        });
    };

    onSubmitModalHandler = (paymentAmount) => {
        const { onSelectAdd } = this.props;
        const { selectedLoyaltyItem } = this.state;

        if (typeof onSelectAdd === 'function') {
            onSelectAdd(selectedLoyaltyItem.id, paymentAmount);
        }

        this.setState({
            isManualInputModalOpen: false,
            isPinModalOpen: false,
            isOtpModalOpen: false,
            selectedLoyaltyItem: null,
            defaultInputPaymentAmount: null,
        });
    };

    onSubmitPinModalHandler = (resp) => {
        const { onRevalidate, amountToPay } = this.props;
        const { selectedLoyaltyItem } = this.state;

        if (typeof onRevalidate === 'function') {
            onRevalidate(resp);
        }

        if (resp.balance < 100 || (resp.maxRedeemableCents < resp.minCents)) {
            this.setState({
                isManualInputModalOpen: false,
                isPinModalOpen: false,
                isOtpModalOpen: false,
                isMessageModalOpen: true,
                modalTitle: selectedLoyaltyItem.insufficientTitle,
                modalMessage: selectedLoyaltyItem.insufficientMessage
            });
        } else {
            var defaultInputPaymentAmount = PrestoAppUtils.convertToCurrency(+(resp.balance < amountToPay ? resp.balance : amountToPay) / 100);
            this.setState({
                isManualInputModalOpen: true,
                isPinModalOpen: false,
                isOtpModalOpen: false,
                clearField: true,
                defaultInputPaymentAmount: defaultInputPaymentAmount,
            }, () => this.setState({ clearField: false }));
        }
    };

    getArrayByID = (id) => {
        const { loyaltyList } = this.props;
        let _arr = loyaltyList.filter(item => (item.id === id));
        return _arr[0];
    };

    isAlreadyAdded = (id) => {
        const { selectedList } = this.props;
        let _arr = selectedList.filter(item => (item.id === id));
        return (_arr.length > 0);
    };

    hasEverythingAdded = () => {
        const { loyaltyList } = this.props;
        for (var i = 0; i < loyaltyList.length; i++) {
            if (!this.isAlreadyAdded(loyaltyList[i].id)) {
                return false;
            }
        }
        return true;
    };

    getMinimumAmount = (loyaltyItem) => {
        if (!loyaltyItem) {
            return 0;
        }
        return +(loyaltyItem.minCents);
    };

    getMaximumAmount = (loyaltyItem) => {
        const { selectedList, paymentData } = this.props;
        const totalPaymentAmount = +(paymentData.amount);

        if (!loyaltyItem) {
            return 0;
        }

        var loyaltyAmount = 0;
        for (var i = 0; i < selectedList.length; i++) {
            if (selectedList[i].id !== loyaltyItem.id) {
                loyaltyAmount = loyaltyAmount + selectedList[i].amount;
            }
        }

        const amountToPay = totalPaymentAmount - loyaltyAmount;

        var maxCents = 0;
        if (amountToPay > +(loyaltyItem.maxRedeemableCents)) {
            maxCents = +(loyaltyItem.maxRedeemableCents);
        } else {
            maxCents = amountToPay;
        }

        if ((amountToPay - maxCents) > 0 && (amountToPay - maxCents) < 100) {
            maxCents = amountToPay - 100;
        }
        return maxCents;
    };

    getSoftMaximumAmount = (loyaltyItem) => {
        const { selectedList, paymentData } = this.props;
        const totalPaymentAmount = +(paymentData.amount);

        if (!loyaltyItem) {
            return 0;
        }

        var loyaltyAmount = 0;
        for (var i = 0; i < selectedList.length; i++) {
            if (selectedList[i].id !== loyaltyItem.id) {
                loyaltyAmount = loyaltyAmount + selectedList[i].amount;
            }
        }

        const amountToPay = totalPaymentAmount - loyaltyAmount;
        return (amountToPay - 100);
    };

    onPaymentInputChange = (input) => {
        this.setState({
            defaultInputPaymentAmount: input,
            clearField: true,
        }, () => this.setState({ clearField: false }));
    };

    render() {
        const {
            isSelectorOpen,
            isManualInputModalOpen,
            isPinModalOpen,
            isOtpModalOpen,
            isMessageModalOpen,
            modalTitle,
            modalMessage,
            selectedLoyaltyItem,
            clearField,
            defaultInputPaymentAmount,
        } = this.state;
        const {
            appState,
            loyaltyList,
            selectedList,
        } = this.props;

        return ( !!loyaltyList ? (
            <React.Fragment>
                { (!this.hasEverythingAdded()) && (
                    <React.Fragment>
                        <LoyaltyTypeMultiSelectorWrapper
                            className={[
                                "loyalty-type-multi-selector",
                                (isSelectorOpen ? ' open' : '')
                            ].join('')}>
                            <div className="preview-area" onClick={this.onToggleHandler}>
                                <div className="selected-loyalty">
                                    <LoyaltyTypePreviewWrapper>
                                        <div className="name">{term_addLoyalty}</div>
                                    </LoyaltyTypePreviewWrapper>
                                </div>
                            </div>
                            <div className="selection-area">
                                <div className="divider" />
                                <div id="loyalty-type-selection-list" className="selection-list-container">
                                    <ul>
                                        {(loyaltyList).map((item, key) => {
                                            return ( (!this.isAlreadyAdded(item.id)) ? (
                                                <li key={key} className="selection-list" onClick={() => this.onSelectHandler(item)} >
                                                    <span className="loyalty-name">
                                                        <LoyaltyTypeMultiName
                                                            icon={item.icon}
                                                            name={item.label}
                                                        />
                                                    </span>
                                                </li>
                                            ) : null );
                                        })}
                                    </ul>
                                    <div className="loyalty-method-disclaimer" dangerouslySetInnerHTML={{__html: term_loyaltyDisclaimerLine}}></div>
                                </div>
                            </div>
                        </LoyaltyTypeMultiSelectorWrapper>
                    </React.Fragment>
                )}

                {(selectedList).map((selectedItem, selectedKey) => {
                    return (
                        <React.Fragment key={selectedKey}>
                            {(loyaltyList).map((item, key) => {
                                return ( (selectedItem.id === item.id) ? (
                                    <React.Fragment key={key}>
                                        <LoyaltyTypeMultiSelectorWrapper className={[
                                            "loyalty-type-multi-selector"
                                            ].join('')}>
                                            <div className="preview-area" >
                                                <div className="selected-loyalty">
                                                    <span className="loyalty-name">
                                                        <LoyaltyTypeMultiName
                                                            icon={item.icon}
                                                            name={item.label}
                                                            amount={ appState.curCode.currency + PrestoAppUtils.convertToCurrency(selectedItem.amount / 100) }
                                                            balance={selectedItem.points}
                                                            actionIcon="editremove"
                                                            onEdit={() => this.onSelectHandler(item)}
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </LoyaltyTypeMultiSelectorWrapper>
                                    </React.Fragment>
                            ) : null );
                            })}
                        </React.Fragment>
                    );
                })}

                <LoyaltyTypeInputModal
                    appState={ appState }
                    clearField= { clearField }
                    defaultVal={ defaultInputPaymentAmount }
                    loyaltyItem={ selectedLoyaltyItem }
                    isOpen={ isManualInputModalOpen }
                    onClose={ this.onCloseModalHandler }
                    onRemove={ this.onRemoveModalHandler }
                    onSubmit={ this.onSubmitModalHandler }
                    onInputChange={ this.onPaymentInputChange }
                    minAmount={ this.getMinimumAmount(selectedLoyaltyItem) }
                    maxAmount={ this.getMaximumAmount(selectedLoyaltyItem) }
                    softMaxAmount= { this.getSoftMaximumAmount(selectedLoyaltyItem) }
                />

                {isPinModalOpen && (
                    <LoyaltyTypePinModal
                        appState={ appState }
                        clearField={ clearField }
                        loyaltyItem={ selectedLoyaltyItem }
                        isOpen={ isPinModalOpen }
                        onClose={ this.onClosePinModalHandler }
                        onSubmit={ this.onSubmitPinModalHandler }
                    />
                )}

                {isOtpModalOpen && (
                    <LoyaltyTypeOtpModal
                        clearField={ clearField }
                        loyaltyItem={ selectedLoyaltyItem }
                        isOpen={ isOtpModalOpen }
                        onClose={ this.onClosePinModalHandler }
                        onSubmit={ this.onSubmitPinModalHandler }
                    />
                )}

                {isMessageModalOpen && (
                    <LoyaltyMessageModal
                        isOpen={ isMessageModalOpen }
                        title= { modalTitle }
                        message= { modalMessage }
                        onClose={ this.onCloseMessageModalHandler }
                    />
                )}
            </React.Fragment>
        ) : null );
    }
}

export default LoyaltyTypeMultiSelector;


const LoyaltyTypeMultiName = ({icon, name, amount, balance, actionIcon, onEdit}) => (
    <LoyaltyTypeMultiNameWrapper className="loyalty-type-name">
        { !!icon && <div className="icon">{icon}</div> }
        { (!!amount) &&
        <div className="name">
            {name} ({amount})
            <br/>
            <span className="points">{balance} PTS</span>
        </div>
        }
        { (!amount) &&
        <div className="name-only">
            {name}
        </div>
        }
        <div className="selectedIcon">
            { !!actionIcon && actionIcon === "editremove" && (
            <React.Fragment>
                <div className="editIcon" onClick={onEdit}><img src="data:image/png;base64,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" alt="Edit" /></div>
            </React.Fragment>
            ) }
        </div>
    </LoyaltyTypeMultiNameWrapper>
);

const iconSize = PrestoAppTheme.layout.fontSizeXLarge;
const iconWidth = "4.0rem";

const LoyaltyTypePreviewWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    
    & .name { 
        font-weight: 400;
        margin-right: ${PrestoAppTheme.layout.xSmallGap};
        margin-left: 0.75rem;
        color: ${PrestoAppTheme.colors.baseBlue};
        width: 100%;
        line-height: 1.5rem;
    }
`;

const LoyaltyTypeMultiNameWrapper = styled.div`
    display: flex;
    align-item: center;

    & .icon { 
        height: 1.5rem;
        width: ${iconWidth};
        margin-right: ${PrestoAppTheme.layout.xSmallGap};
        text-align: center;
    
        & > img {
            max-width: 100%;
            max-height: 100%;
            padding-top: 0.125rem;
            padding-bottom: 0.125rem;
        }
    }

    & .icon { 
        display: block;
    }

    & .name { 
        font-weight: 400;
        margin-right: ${PrestoAppTheme.layout.xSmallGap};
        font-size: 0.75rem;
        line-height: 0.875rem;
        width: 100%;
        
        & .points { 
            color: #888888;
            font-weight: 300;
        }
    }
    
    & .name-only { 
        font-weight: 400;
        margin-right: ${PrestoAppTheme.layout.xSmallGap};
        line-height: 1.75rem;
        width: 100%;
    }
    
    & .selectedIcon {
        width: 5.5rem;
        overflow: hidden;
        text-align: right;
        height: 28px;
        
        & .editIcon {
            height: 1.5rem;
            width: 1.5rem;
            display: inline-block;
            padding: 0.125rem 0;
            margin-right: 0.5rem;
                        
            & > img {
                width: 100%;
            }
        }
        
        & .removeIcon {
            height: 1.5rem;
            width: 1.5rem;
            display: inline-block;
            padding: 0.125rem 0;
                        
            & > img {
                width: 100%;
            }
        }
    }
`;

const LoyaltyTypeMultiSelectorWrapper = styled.div`
    padding: ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.smallGap} 0;
    border: 1px solid ${PrestoAppTheme.colors.baseSnowDark};
    border-radius: ${PrestoAppTheme.layout.borderRadius};

    &.has-error {
        border-radius: ${PrestoAppTheme.layout.borderRadius} ${PrestoAppTheme.layout.borderRadius} 0 0;
    }

    & .preview-area {
        display: flex;
        justify-content: space-between;
        padding-bottom: ${PrestoAppTheme.layout.smallGap};

        & .selected-loyalty {
            width: 100%;
        }
    }
    
    & .selection-area {
        width: calc(100% + 2 * ${PrestoAppTheme.layout.smallGap});
        margin-left: -${PrestoAppTheme.layout.smallGap};

        & .divider { 
            height: 0;
            background-color: ${PrestoAppTheme.colors.baseSnowDark};
            transition: height 10ms 300ms;
        }
        
        & .selection-list-container {
            max-height: 0;
            overflow: hidden;
            transition: max-height 300ms;

            & .loyalty-method-disclaimer {
                padding: 0.4rem ${PrestoAppTheme.layout.largeGap};
                color: ${PrestoAppTheme.colors.baseGreyDark};
                font-weight: 300;
                text-align: start;
                font-size: 0.8rem;

                & a {
                    color: ${PrestoAppTheme.colors.baseBlue};
                }
            }

            & > ul {
                ${PrestoAppTheme.layout.blankListStyle}
    
                & .selection-list {
                    padding: 0.4rem ${PrestoAppTheme.layout.smallGap};
                    line-height: ${iconSize};
                    color: ${PrestoAppTheme.colors.baseBlack};
                    cursor: pointer;
                    display: flex;
        
                    & .loyalty-name { 
                        display: inline-block;
                        margin-right: ${PrestoAppTheme.layout.xSmallGap};
                        vertical-align: middle;
                        width: 100%;
                    }

                    &:hover {
                        background-color: ${PrestoAppTheme.colors.baseSnow};
                    }
                }
                
                & .hidden {
                    display: none;
                }
            }
        }
    }

    &.open {
        & .selection-area {
            & .divider { 
                height: 1px;
                transition: height 10ms 1ms;
            }
            
            & .selection-list-container {
                max-height: 200px;
                overflow: auto;
                transition: max-height 400ms;
            }
        }
    }
`;
